import React, { useEffect, useState } from 'react';
import T from 'prop-types';

import Button from '../../../../../components/Buttons/Button';
import WarningModal from '../../../../../components/Modals/WarningModal';

const ReleasedWithinLastYearNotification = ({
  link,
}) => (
  <div className="widget-body less-than-year">
    <div className="widget-body__description">
      This app was released within the last 12 months, and lacks Year-over-Year historical data.
    </div>
    <Button
      variant="secondary"
      size="sm"
      href={link}
    >
      Go to Performance Overview
    </Button>
  </div>
);

ReleasedWithinLastYearNotification.propTypes = {
  link: T.string,
};

export default ReleasedWithinLastYearNotification;

const warningModalText = {
  header: 'Limited historical data',
  text: 'This app was released within the last 12 months, and lacks Year-over-Year historical data. For a better view of current performance, please go to Performance Overview.',
  confirmButtonText: 'Go to Performance Overview',
};

export const ReleasedWithinLastYearWarnModal = ({
  show,
  link,
}) => {
  const [warningOpen, setWarningOpen] = useState(false);

  useEffect(() => {
    if (show) {
      setWarningOpen(show);
    }
  }, [show]);

  return warningOpen ? (
    <WarningModal
      {...warningModalText}
      open={warningOpen}
      warningUrl={link}
      onClose={() => setWarningOpen(false)}
    />
  ) : null;
};

ReleasedWithinLastYearWarnModal.propTypes = {
  show: T.bool,
  link: T.string,
};
